import { useMemo } from 'react'
import { useQuery } from '@apollo/client'

import {
  OPERATION_FIND_RAN_ROOMS_REMAINING,
  buildRanRoomsRemainingBySsidQuery,
  getSsidRemainingAlias
} from './operations-gql/queries'

const useRemainingKeys = ({ siteId, ssids, skip }) => {
  const hasSsids = Boolean(ssids?.length)
  const bySsidQuery = useMemo(
    () => (hasSsids ? buildRanRoomsRemainingBySsidQuery(ssids) : OPERATION_FIND_RAN_ROOMS_REMAINING),
    [hasSsids, ssids]
  )
  const totalResult = useQuery(OPERATION_FIND_RAN_ROOMS_REMAINING, {
    variables: { sf_id: siteId },
    skip: skip || !siteId || hasSsids
  })
  const bySsidResult = useQuery(bySsidQuery, {
    variables: { sf_id: siteId },
    skip: skip || !siteId || !hasSsids
  })

  if (!hasSsids) {
    return {
      loading: totalResult.loading,
      error: totalResult.error,
      count: totalResult.data?.count,
      bySsid: null
    }
  }

  return {
    loading: bySsidResult.loading,
    error: bySsidResult.error,
    count: undefined,
    bySsid: ssids.map(({ id, name }, index) => ({
      id: String(id),
      name,
      count: bySsidResult.data?.[getSsidRemainingAlias(index)]
    }))
  }
}

export default useRemainingKeys
